module.exports = __webpack_public_path__ + "static/media/ICON_CAMERA.c984ae6b.svg";